import Simulation from "./simulation.jsx";

export default Simulation;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/simulation/index.js